/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Step_SummaryInputs */

const cs_ebr_step_summary = /** @type {(inputs: Ebr_Step_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhrn`)
};

const en_ebr_step_summary = /** @type {(inputs: Ebr_Step_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Ebr_Step_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_step_summary = /** @type {((inputs?: Ebr_Step_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Step_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_step_summary(inputs)
	return cs_ebr_step_summary(inputs)
});